import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ShareIcon from 'svg/share.svg';
import App from 'modules/App';
import { useAction } from 'hooks';
const ShareBtn = ({ url, title, text })=>{
    const setAlert = useAction(App.actions.setAlert);
    const shareData = {
        title: title || '',
        text: text || '',
        url
    };
    const onShareHandler = async ()=>{
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error(err);
            setAlert({
                type: 'error',
                message: App.messages.alerts.genericError
            });
        }
    };
    return /*#__PURE__*/ _jsx(ShareIcon, {
        onClick: onShareHandler
    });
};
export default ShareBtn;
